module.exports = __webpack_public_path__ + "assets/img/35b51d75235e5df85e8bd4d892e47505.png";